import { Code } from '@atlaskit/code';
import * as React from 'react';
export default {
  Code,
  React
};